
var api = "https://api.qingcigame.com";
var activeKey = 'f87f6fa41d2d9271985c70a63ffcee60'; // 第七期

var user_id_arr = [];
const config = {
    account: "",
    channel: "",
    id: "",
    platform: "",
    area: "",
    game_id: 60,
    role_id: "",
    page_id: 11,
    roleName: ''
};
let bindParams = {};
let timer = null;
let wait = 60;

var filterData = '';
let jsonDataId = [
    { id: 35, xff: 62, zsf: 35 }, // 时光id对应的服务器
    { id: 67, xff: 25, zsf: 67 }, // 使魔id对应的服务器
    { id: 39, xff: 26, zsf: 39 }, // 蜗牛id对应的服务器
    { id: 33, xff: 42, zsf: 33 }, // 提灯id对应的服务器
    { id: 58, xff: 58, zsf: 69 }, // 仙剑id对应的服务器
    { id: 74, xff: 61, zsf: 74 }, // 小樱id对应的服务器2
    { id: 82, xff: 40, zsf: 82 }, // 刃心2id对应的服务器
    { id: 87, zsf: 87 }, // 刃心1id对应的服务器
    { id: 48, zsf: 48 }, // 超喵星id对应的服务器
    { id: 47, zsf: 47 }, // 骑士冲呀id对应的服务器
    { id: 50, zsf: 50 }, // 迷途之光id对应的服务器
]

var initialSlide = 0; //设置默认索引为0

var currentTime = new Date();
var specifiedTime = new Date('2025-04-02T10:00:00'); // 将此处替换为你的指定时间
var options = currentTime < specifiedTime ? [
    '祈月之禮，溯星之約。CLAMP雜誌夢幻卡池限時上架，點選查看>>',
    '🌸✨小櫻生日來啦！「祈月之禮」全套滿階卡池錦鯉發放中，快來領取好運>>',
    '《庫洛魔法使：回憶鑰匙》「祈月之禮」夢幻盲盒現已開啟！快來把全新小小櫻帶回家！ >>'
] : [
    '祈月之禮，溯星之約。CLAMP雜誌夢幻卡池限時上架，點選查看>>',
    '🌸✨小櫻生日來啦！「祈月之禮」全套滿階卡池錦鯉發放中，快來領取好運>>',
    '《庫洛魔法使：回憶鑰匙》「祈月之禮」夢幻盲盒現已開啟！快來把全新小小櫻帶回家！ >>'];

var shareText = options[Math.floor(Math.random() * options.length)];

var requestInterface = {};
var routerParams = {};
var awardNum = 0; // 可以领取的奖励数量
var gameNum = 0; // 游戏次数
var isBindRole = false;
let lastClickTime = 0; // 最后一次点击抽奖按钮时间
let taskBind = 0; //是否是任务绑定
const cutdown = 1000;
// 初始化数组，表示每个 lock 的状态
let lockStatus = ["lock", "lock", "lock", "lock", "lock", "lock", "lock"];

let selectedWordsList = [
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', '']
];
let selectedWordsSureList = [
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
];
let selectedWordsSure = [];
let selectedWords = ['', '', '', '', '', ''];
let showWords = ['蛋', '生', '樂', '的', '小', '日', '快', '愛', '櫻', '糕'];
let answerWords = '';
let wordList = [
    ['蛋', '生', '樂', '的', '小', '日', '快', '愛', '櫻', '糕'],
    [],
    ['刻', '線', '時', '鐘', '定', '限', '法', '表', '一', '魔'],
    [],
    ['運', '星', '櫻', '行', '出', '走', '天', '幸', '小', '春'],
    [],
    ['羽', '心', '純', '翔', '翼', '翅', '飛', '白', '箱', '春']
]
let rewards_list = [
    ['星之幣*200', '3~5星小小櫻碎片寶箱*3'],
    [],
    ['櫻花幣*50', '友枝幣*200W',],
    [],
    ['星之幣*200', '3~5星小小櫻碎片寶箱*5'],
    [],
    ['小櫻專屬頭像框*1', '高級盲盒兌換券*2']
]
// let startTime = new Date('2025-04-01T10:00:00');
let startTime = new Date('2025-03-14T10:00:00');
let daysPassed = 0;
let activityInfo = {};


function showSelectWordsFn() {
    $(".choose_word_box .grid").each(function (index) {
        $('.word_container .grid').removeClass('grid_choose')
        $('.word_container .grid').removeClass('grid_text')
        const newArray = selectedWords.filter(word => word !== '');
        if (newArray.length < 1) return
        if (index < selectedWords.length) {
            $(this).text(selectedWords[index]);  // 赋值文字
            let showIndex = showWords.findIndex(word => word === selectedWords[index]);
            console.log('index', showIndex)
            if (showIndex !== -1) {
                console.log('index', showIndex)
                setTimeout(() => {
                    $('.word_container .grid').eq(showIndex).addClass('grid_choose')
                }, 100)
            }
            // 判断该按钮是否被锁定
            let activeIndex = $(".lock_box .lock.unlock_active").index();
            selectedWordsSure = selectedWordsSureList[activeIndex];
            let selectedWordsSureNum = selectedWordsSure.length < 1 ? -1 : selectedWordsSure;
            if (index <= selectedWordsSureNum) {
                $(this).addClass('grid_active'); // 复制选择框
            } else {
                if (selectedWords[index] !== '') {
                    $(this).addClass('grid_text'); // 复制选择框
                    // 添加关闭按钮
                    $(this).append(`<div class="close"></div>`);
                }
            }
        } else {
            return false; // 避免越界
        }
    });
}
function bind_btn_fn() {
    layer.msg("請先綁定角色");
    $('.task_popup').fadeOut();
    // 未綁定的讓玩家綁定角色
    taskBind = 1
    obj.serverInfo(config.account);
    return false;
}

var obj = {
    loopInt: null,
    taskInitNum: null,

    index: function () {
        this.isToken();
        this.onAdapt();
        this.indexBind(); // 首页按钮
        this.helpRecord(); // 帮助记录
        this.preloading(); // 帮助记录
    },
    helpRecord: function () {
        routerParams = analysisParams(window.location.href);
        let strId = window.localStorage.getItem('helper_id');
        if (strId == null) return
        let user_id_arr = [...new Set(strId.split(",").map(Number))];
        // console.log(user_id_arr);
        // console.log(routerParams.helper_id)

        // 帶幫助id則執行
        if (routerParams.helper_id !== undefined) {
            if (window.localStorage.getItem('helper_id') !== null) {
                // 幫助id是否包含在緩存中
                if (!window.localStorage.getItem('helper_id').includes(routerParams.helper_id)) {
                    // alert('不包含')
                    shareRecords();
                }
            }
        }

        function shareRecords() {
            requestInterface.countNum('小櫻_第七期_移動端_通過複製鏈接點入');
            requestInterface.share({ helper_id: routerParams.helper_id });
            // 再次記錄到緩存數組裡
            user_id_arr.push(routerParams.helper_id);
            window.localStorage.setItem('helper_id', user_id_arr);
        }
    },
    onAdapt: function () {
        // 小屏自適應
        const width = $(window).width();
        const height = $(window).height();
        const aspectRatio = Number((width / height).toFixed(3));
        // alert('aspectRatio:' + aspectRatio);
        // console.log('aspectRatio', aspectRatio);
        if (aspectRatio >= 0.63) {
            $('body').addClass('adapt-2');
        } else if (aspectRatio >= 0.585) {
            $('body').addClass('adapt-1');
        } else if (aspectRatio >= 0.5) {
            $('body').addClass('adapt-3');
        } else if (aspectRatio >= 0.4) {
            $('body').addClass('adapt-4'); // 很長的機型
        }
    },
    isToken: function () {
        const params = analysisParams(window.location.href);
        let roleID = params.role_id;
        let roleSign = params.sign;
        if (roleID) {
            localStorage.setItem('roleID', roleID);
            localStorage.setItem('sign', roleSign);
            window.location.href = window.location.origin + window.location.pathname; // 重定向
        }
        // 記緩存
        var role_id = localStorage.getItem('roleID');
        var sign = localStorage.getItem('sign');
        if (role_id) {
            requestInterface.accountLogin({ role_id: role_id, game_id: 60, card: 1, sign: sign }, function (response) {
                localStorage.setItem('access_token', response.data.access_token);
                $('.popup').fadeOut();
                obj.onInit();
            });
        } else {
            obj.onInit();
        }
    },
    preloading: function () {
        // $('.preload_icon').fadeIn(); 
        var queue = new createjs.LoadQueue();
        queue.on("progress", function (e) {

            // 加載中的進度
            if (e.progress * 100 >= 10) {
                $(".preloading #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function (e) {
            // 加載完成執行操作
            $('.content').addClass('index-show');
            this.indexSwiper();
            setTimeout(function () {
                $('.preloading').fadeOut();
                setTimeout(function () {
                    $('.preloading').remove();
                }, 1000)
            }, 1000)
        }, this);
        queue.loadManifest([
            '/card-pool-7/images/mobile/preloading_bg-5a2a8189ba.png',
            '/card-pool-7/images/mobile/index_bg-016de90642.png',
            '/card-pool-7/images/mobile/slogan-26660a03d2.png',
            '/card-pool-7/images/mobile/header_bg-83e4da8f8a.png',
            '/card-pool-7/images/mobile/preloading_icon-9b3026823f.png',
            '/card-pool-7/images/mobile/login_btn-19793864c5.png',
            '/card-pool-7/images/mobile/download_btn-f39f721482.png',
            '/card-pool-7/images/mobile/6/reward1-2047182d74.png',
            '/card-pool-7/images/mobile/6/reward2-834ec2565c.png',
            '/card-pool-7/images/mobile/6/reward3-663d9bb5f8.png',
            '/card-pool-7/images/mobile/6/reward4-d16c6829e8.png',
            '/card-pool-7/images/mobile/6/reward5-78245675cf.png',
            '/card-pool-7/images/mobile/6/reward6-834ec2565c.png',
            '/card-pool-7/images/mobile/6/reward7-c6ad2b7dd8.png',
            '/card-pool-7/images/mobile/6/blessing2-ec64563a9b.png',
            '/card-pool-7/images/mobile/6/blessing4-8942cd5efa.png',
            '/card-pool-7/images/mobile/6/blessing6-fc42344695.png',
            '/card-pool-7/images/mobile/popup/day1-e70eb163f6.png',
            '/card-pool-7/images/mobile/popup/day2-c7644e8031.png',
            '/card-pool-7/images/mobile/popup/day3-599f9ddd9b.png',
            '/card-pool-7/images/mobile/popup/day4-76296c451c.png',
            '/card-pool-7/images/mobile/popup/day5-2f1bfed3eb.png',
            '/card-pool-7/images/mobile/popup/day6-4183c14b6e.png',
            '/card-pool-7/images/mobile/popup/day7-734b6afde6.png',
        ]);
    },
    // 時間初始化
    reloadTimeInit: function () {



        let data_access_token = localStorage.getItem('access_token') || '';
        for (let i = 0; i < daysPassed && i < lockStatus.length; i++) {
            lockStatus[i] = "unlock"; // 过去一天解锁一个
        }
        // 输出更新后的数组
        console.log("过去天数:", daysPassed);
        console.log("当前 lockStatus 状态:", lockStatus);
        // 1️⃣ 初始化 `.lock` 的状态
        $(".lock_box .lock").each(function (index) {
            $(this).addClass(lockStatus[index]); // 赋予对应的 lock/unlock 类
            // 不含有token和当前不在答题,则不激活第一个,且当前没有激活的
            let activeIndex = $(".lock_box .lock.unlock_active").index();
            if (!data_access_token || activeIndex === -1) {
                $(".lock_box .lock").eq(0).addClass("unlock_active"); // 选中第一个 unlock
                let word_box_mini_img = $(".word_box_mini_img");
                word_box_mini_img.removeClass(function (index, className) {
                    return (className.match(/word\d+/) || []).join(" ");
                });
                let dayNum = $(".day_num");
                dayNum.removeClass(function (index, className) {
                    return (className.match(/day_\d+/) || []).join(" ");
                });
                // 更新 day_num 的类名：先移除之前的 day_xxx 类，再添加新的 day_{index-1}
                let reward_tips = $(".content_box .reward_tips");
                reward_tips.removeClass(function (index, className) {
                    return (className.match(/reward_\d+/) || []).join(" ");
                });
                $(".word_box_mini_img").addClass("word1"); // 默认 day_num 设为 day_0
                $(".day_num").addClass("day_1"); // 默认 day_num 设为 day_0
                $(".reward_tips").addClass("reward_1"); // 默认 day_num 设为 day_0
            }
        });
    },
    indexBind: function () {
        const _this = this
        // 點擊 .popup 觸發關閉
        $(".popup.answer_popup,.popup.gift_popup,.my_prize_popup,.task_popup,.cg_popup,.share_popup,.bind_confirm_popup,.reward_popup,.wechat_popup,.enterprise_wechat_popup,.rule_popup,.pass_popup,").click(function () {
            $(this).fadeOut();
        });
        // 点击 .popup_box 不关闭
        $(".popup_box.answer_popup,.popup.gift_popup,.my_prize_popup,.task_list,.cg_load,.share_box,.bind_confirm_box,.reward_box,.wechat_box,.rule_box,.pass_box, ").click(function (event) {
            event.stopPropagation(); // 阻止冒泡，防止关闭 popup
        });
        // 延遲掛載任務事件
        setTimeout(function () {
            if (!$('.task_pop .task_list li .move_btn').data('hasClickEvent')) {
                $('.task_pop .task_list li .move_btn').on('click', function () {
                    const link = $(this).attr('link');
                    const index = $(this).closest('li').index(); // 獲取當前 <li> 的索引

                    requestInterface.countNum(`小櫻_第七期_移動端_任務_${index}`);
                    if (index == 0 && !activityInfo.is_bind) {
                        return
                    }
                    obj.taskInitNum = index;
                    if (index == 0) {
                        // 綁定事件監聽
                        return window.open(link, '_blank')
                    } else {
                        setTimeout(function () {
                            const data = {
                                task_id: index + 1,
                            }
                            data.key = activeKey;
                            data.access_token = localStorage.getItem('access_token') || '';
                            $.ajax({
                                url: api + '/sea/cherry/taiwan/draw/task',
                                type: "POST",
                                data,
                                xhrFields: { withCredentials: true },
                                success: function (json) {
                                    obj.onInitForTask();// 重新初始化
                                    if (json.code != 200) {
                                        layer.msg(json.message);
                                        return false;
                                    }
                                },
                                complete: function () {
                                    layer.close(index);
                                }
                            })
                        }, 2000)
                    }
                    return window.open(link, '_blank')
                });
            }
        }, 1000)
        // 點擊下載圖片
        $("#downloadBtn").click(function () {
            let visibleImages = $(".cg_image").filter(function () {
                return $(this).css("display") === "block";
            }).map(function () {
                return $(this).find("img").attr("src");
            }).get();

            requestInterface.countNum('小櫻_第七期_移動端_下載CG圖片');
            console.log("所有可見圖片的 src:", visibleImages);
            var imgUrl = visibleImages[0]; // 獲取圖片 URL
            var link = document.createElement("a");
            link.href = imgUrl;
            link.download = "downloaded-image.png"; // 自定義下載文件名 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });

        // 登陸相關綁定事件
        obj.loginEventBind();
        // 初始化時間
        obj.reloadTimeInit()
        // 打開每日任務
        $('.remaining').on('click', function (event) {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            event.stopPropagation(); // 阻止冒泡，防止關閉 popup

            const f_btn = $('.task_pop .task_list li .move_btn').first();

            if (!activityInfo.is_bind) {
                console.log('未綁定');
                f_btn.removeClass('bind_btn');
                f_btn.addClass('bind_btn');
                // 移除 bind_btn_fn 事件
                $('.bind_btn').off('click', bind_btn_fn);
                $('.bind_btn').on('click', bind_btn_fn);
            } else {
                $('.bind_btn').off('click', bind_btn_fn);
                f_btn.removeClass('bind_btn');
            }
            $('.task_popup').fadeIn();

        })


        function showWordsFn() {
            $(".word_container .grid").each(function (index) {
                if (index < showWords.length) {
                    $(this).text(showWords[index]);  // 賦值文字
                } else {
                    return false; // 避免越界
                }
            });
        }
        showWordsFn();
        // 回答問題的函數
        function answerFn(answer, answer_id, callback) {
            // 過濾出 selectedWords 在 showWords中的索引
            let selectedIndexes = selectedWords
                .map(word => showWords.indexOf(word))  // 獲取索引
                .filter(index => index !== -1); // 過濾掉找不到的 (-1)
            let selectedIndexesStr = selectedIndexes.join('');
            let activeIndex = $(".lock_box .lock.unlock_active").index();
            // 填入六個字符可以回答
            const index = layer.load(1);
            const data = {
                answer: selectedIndexesStr,
                answer_id: answer_id,
            }
            data.key = activeKey;
            data.access_token = localStorage.getItem('access_token') || '';
            $.ajax({
                url: api + '/sea/cherry/taiwan/draw/answer',
                type: "POST",
                data,
                xhrFields: { withCredentials: true },
                success: function (json) {
                    obj.onInit();
                    if (json.code === 406) {
                        $('.fail_popup').fadeIn();
                        selectedWordsList[activeIndex]
                        let answer_words = ['', '', '', '', '', '']
                        for (let i = 0; i <= selectedWordsSure; i++) {
                            // 循環體會遍歷 i=0, 1, ..., selectedWordsSure
                            answer_words[i] = selectedWordsList[activeIndex][i]
                        }
                        console.log(answer_words);
                        selectedWordsList[activeIndex] = answer_words
                        selectedWords = answer_words
                        console.log('answer_words', answer_words)
                        // 重置選擇框
                        $(".choose_word_box .grid")
                            .removeClass()    // 移除所有類名
                            .addClass("grid") // 重新添加 grid 類（確保保留該類）
                            .text("");        // 清空 div 中的文字
                        $(".word_container .grid")
                            .removeClass()    // 移除所有類名
                            .addClass("grid") // 重新添加 grid 類（確保保留該類）
                        showSelectWordsFn()
                        layer.msg(json.message);
                        return false;
                    }
                    if (json.code == 405) {
                        layer.msg(json.message);
                        return false;
                    }
                    if (json.code == 403) {
                        layer.msg(json.message);
                        return false;
                    }
                    callback && callback(json);
                },
                complete: function () {
                    layer.close(index);
                }
            })
        }
        // 確認字符
        $('.opt_box .sure_word').on('click', function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            function findFirstDiffIndex() {
                // 查找第一個符合條件的 `div` 並獲取索引
                let index = $(".choose_word_box .grid").filter(function () {
                    return $(this).hasClass("grid_text") && !$(this).hasClass("grid_active");
                }).first().index();

                // 如果找不到匹配項，返回 -1
                index = (index !== -1) ? index : -1;
                return index;
            }


            let diffIndex = findFirstDiffIndex();
            if (activityInfo.answer_info.dice_times < 1) return layer.msg('機會用完了');
            if (diffIndex < 0) return layer.msg('請先選擇字符');

            const index = layer.load(1);
            let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引
            // 過濾出 selectedWords 在 showWords中的索引

            let allHaveRequiredClass = true;
            for (let i = 0; i < diffIndex; i++) {
                let element = $(".choose_word_box .grid").eq(i);
                if (!element.hasClass("grid_text") && !element.hasClass("grid_active")) {
                    allHaveRequiredClass = false;
                    break;
                }
            }
            if (!allHaveRequiredClass) {
                layer.close(index);
                return layer.msg("前方有未輸入字符", { time: 1000 });
            }

            // 已選擇的字符
            let grid_text = $('.choose_word_box .grid_text')
            // 待選中的字符
            let grid = $('.word_container .grid')

            // grid_text.eq(diffIndex).addClass('error'); // 添加error類
            grid.eq(answerWords[diffIndex]).addClass('error'); // 添加error類   
            setTimeout(() => {
                // 獲取字符待選的索引
                let showIndex = showWords.findIndex(word => word === selectedWords[diffIndex]);
                // grid_text.eq(diffIndex).removeClass('error'); // 移除error類
                grid.eq(showIndex).removeClass('grid_choose'); // 移除選中類
                grid.eq(answerWords[diffIndex]).removeClass('error'); // 移除error類
                console.log("當前zq字符索引：", diffIndex);
                selectedWords[diffIndex] = showWords[answerWords[diffIndex]]
                selectedWordsList[activeIndex] = selectedWords
                // 確定文字存入數組
                selectedWordsSureList[activeIndex] = diffIndex
                selectedWordsSure = selectedWordsSureList[activeIndex]
                console.log("已選文字數組存檔：", selectedWordsList);
                console.log("已選文字數組：", selectedWords);
                console.log("當前確認字符", selectedWordsSure);
                console.log("當前確認字符數組", selectedWordsSureList);
                showSelectWordsFn()
                layer.close(index);
            }, 1000);
            console.log("第一個不同的索引是:", diffIndex);
            // return obj.onInit();
            // 請選擇文字
            if (diffIndex < 0) return layer.msg('請選擇文字');
            const data = {
                answer_id: activeIndex + 1,
                number: diffIndex + 1
            }
            data.key = activeKey;
            data.access_token = localStorage.getItem('access_token') || '';

            $.ajax({
                url: api + '/sea/cherry/taiwan/draw/answer/get',
                type: "POST",
                data,
                xhrFields: { withCredentials: true },
                success: function (json) {
                    if (json.code != 200) {
                        layer.msg(json.message);
                        return false;
                    }
                    requestInterface.countNum('小櫻_第七期_移動端_確認一次字符');
                    // obj.onInit();// 重新初始化
                    activityInfo.answer_info.dice_times = activityInfo.answer_info.dice_times - 1
                    $('.remaining .dice_times').text(`${activityInfo.answer_info.dice_times}`)
                },
                complete: function () {
                }
            })
        })
        // 回答問題
        $('.opt_box .submit').on('click', function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            let answer = selectedWords;
            // 獲取選擇的關卡
            let activeIndex = $(".lock_box .lock.unlock_active").index();
            const newArray = selectedWords.filter(word => word !== '');
            if (newArray.length < 6) {
                layer.msg("請選擇6個字", { time: 1000 });
                return false;
            }

            // 過濾出 selectedWords 在 showWords中的索引
            let selectedIndexes = selectedWords
                .map(word => showWords.indexOf(word))  // 獲取索引
                .filter(index => index !== -1); // 過濾掉找不到的 (-1)
            let selectedIndexesStr = selectedIndexes.join('');

            const callback = () => {
                if (selectedIndexesStr === answerWords) {
                    // $('.answer_popup').fadeIn();
                    // 清除獎勵
                    $(".answer_pop .prop_name").remove();
                    setTimeout(() => {
                        // 定義獎勵數組
                        let rewards = rewards_list[activeIndex]
                        // 遍歷數組，並將每個元素添加到 .answer_pop 容器中
                        rewards.forEach(function (reward) {
                            let propDiv = $("<div>").addClass("prop_name").text(reward);
                            $(".answer_pop").append(propDiv);
                        });
                        $('.answer_popup').fadeIn();
                        console.log("獎勵已添加到 .answer_pop");
                    }, 500)


                }
            }
            requestInterface.countNum('小櫻_第七期_移動端_提交答案');

            answerFn(selectedIndexesStr, activeIndex + 1, callback);
            console.log("已選字的索引字符串:", selectedIndexesStr);
            console.log("已選字的索引數組:", selectedIndexes);
        })
        $('.gift_pop .confirm_btn').on('click', function () {
            let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引
            let selectedIndexesStr = ''
            if ($('.gift_btn.accept').hasClass('accept_disabled')) {
                console.log("✅ 該元素包含 accept_disabled 類");
                return
            }
            const callback = () => {
            }
            requestInterface.countNum(`小櫻_第七期_移動端_接受祝福`);
            answerFn(selectedIndexesStr, activeIndex + 1, callback);
        });
        // 領取祝福
        $('.gift_btn.accept').on('click', function () {
            let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引
            let selectedIndexesStr = ''
            if ($('.gift_btn.accept').hasClass('accept_disabled')) {
                console.log("✅ 該元素包含 accept_disabled 類");
                return
            }


            // 更新 day_num 的類名：先移除之前的 day_xxx 類，再添加新的 day_{index-1}
            let gift_content = $(".gift_popup .gift_content");
            gift_content.removeClass(function (index, className) {
                return (className.match(/gift_\d+/) || []).join(" ");
            });
            gift_content.addClass(`gift_${activeIndex + 1}`); // 設置新的類名
            $('.gift_popup').fadeIn();
        })

        // 2️⃣ 綁定點擊事件，只能點擊 unlock 狀態的元素
        $(".lock_box .lock").click(function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            let index = $(this).index(); // 獲取當前點擊的索引
            if ($(this).hasClass('unlock_active')) return false;
            if (lockStatus[index] === "unlock") {
                if (index >= activityInfo.answer_info.now_answer_id) return layer.msg("別急哦~需要完成前置關卡才可繼續解鎖！");
                // 移除所有 unlock_active 狀態，只保留當前的
                $(".lock_box .lock").removeClass("unlock_active");
                $(this).addClass("unlock_active");
                // 清空所有 grid_text 狀態
                $(".choose_word_box .grid").text("").removeClass("grid_active");
                $(".choose_word_box .grid").text("").removeClass("grid_text");
                // 移除 `.word_container .grid` 的 `grid_choose` 類
                $(".word_container .grid").removeClass("grid_choose");

                let word_box_mini_img = $(".word_box_mini_img");
                word_box_mini_img.removeClass(function (index, className) {
                    return (className.match(/word\d+/) || []).join(" ");
                });
                word_box_mini_img.addClass(`word${index + 1}`); // 設置新的類名

                // 更新 day_num 的類名：先移除之前的 day_xxx 類，再添加新的 day_{index-1}
                let dayNum = $(" .day_num");
                dayNum.removeClass(function (index, className) {
                    return (className.match(/day_\d+/) || []).join(" ");
                });
                dayNum.addClass(`day_${index + 1}`); // 設置新的類名

                // 更新 day_num 的類名：先移除之前的 day_xxx 類，再添加新的 day_{index-1}
                let reward_tips = $(".content_box .reward_tips");
                reward_tips.removeClass(function (index, className) {
                    return (className.match(/reward_\d+/) || []).join(" ");
                });
                reward_tips.addClass(`reward_${index + 1}`); // 設置新的類名
                showWords = activityInfo.answer_info.problem_info[index].problem;
                answerWords = activityInfo.answer_info.problem_info[index].answer;
                // 猜謎或者接受祝福
                if (showWords.length < 1) {
                    $('.word_box').fadeOut();
                    $('.reward_tips').fadeOut();
                    $('.gift_intro').fadeIn();
                    let gift_intro = $(".content_box .gift_intro");
                    gift_intro.removeClass(function (index, className) {
                        return (className.match(/gift_intro_\d+/) || []).join(" ");
                    });
                    gift_intro.addClass(`gift_intro_${index + 1}`); // 設置新的類名
                    // 判斷是否已完成
                    if (index + 1 < activityInfo.answer_info.now_answer_id) {
                        $('.gift_intro .accept').addClass('accept_disabled')
                    } else {
                        $('.gift_intro .accept').removeClass('accept_disabled')
                    }
                } else {
                    if (index + 1 < activityInfo.answer_info.now_answer_id) {
                        $('.word_intro').addClass('word_done')
                        answerWords.split('').forEach(function (word, index) {
                            $(".choose_word_box .grid").eq(index).text(activityInfo.answer_info.problem_info[0].problem[word * 1]).addClass("grid_text");
                        })
                    } else {
                        $('.word_intro').removeClass('word_done')
                    }
                    $('.word_box').fadeIn();
                    $('.reward_tips').fadeIn();
                    $('.gift_intro').fadeOut();
                    showWordsFn()
                }
                console.log("當前顯示的答案：", showWords);
            } else {
                layer.msg('明日開啟新關卡')
            }
            selectedWords = selectedWordsList[index]
            selectedWordsSure = selectedWordsSureList[index]
            if (selectedWordsSure > -1 && selectedWords.length <= 0) {
                for (var i = 0; i <= selectedWordsSure; i++) {
                    selectedWordsList[index].push(showWords[answerWords[i]])
                }
            }
            console.log("當前鎖定的答案：", selectedWordsSure);
            showSelectWordsFn()
            console.log("答題保存", selectedWords, selectedWordsList);
        });

        // 猜字謎遊戲
        $(".word_container .grid").click(function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            // 已選擇過的格子不能再選
            if ($(this).hasClass("grid_choose")) return console.log("已選擇");
            let selectedText = $(this).text().trim();

            let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引
            // 找到第一個空白格子（沒有 grid_text grid_active）
            let emptyGrid = $(".choose_word_box .grid").filter(function () {
                // 修改为不存在 grid_active 或者 grid_text 且字符为空
                return !$(this).hasClass("grid_active") && $(this).text().trim() === '';
            }).first()
            // 如果空格子存在 並且 該字未被選擇
            if (emptyGrid.length) {
                // 把字填充到空白格
                emptyGrid.text(selectedText).addClass("grid_text");
                // 添加關閉按鈕
                emptyGrid.append('<div class="close"></div>');

                // 給點擊的字添加選中狀態，防止重複選擇
                $(this).addClass("grid_choose");

                // 存入數組
                const index = selectedWords.indexOf('');
                selectedWords[index] = selectedText;
                selectedWordsList[activeIndex] = selectedWords
                console.log("已選文字數組存檔：", selectedWordsList);
                console.log("已選文字數組：", selectedWords);
            }
        });

        // 監聽 .close 按鈕點擊，清空已選字，並恢復可選狀態,如果含有error狀態就清除
        $(document).on("click", ".choose_word_box .grid .close", function (event) {
            event.stopPropagation(); // 阻止事件冒泡
            let removedText = $(this).parent().text().trim(); // 獲取被移除的字
            // 清空當前格子，並移除選中狀態
            $(this).parent().text("").removeClass("grid_text");
            $(this).remove(); // 刪除關閉按鈕
            // 移除錯誤狀態
            $(".choose_word_box .grid.error").removeClass("error");
            $(".word_container .grid.error").removeClass("error");
            // 在數組中刪除這個字
            selectedWords = selectedWords.map(word => word === removedText ? '' : word);
            let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引\
            selectedWordsList[activeIndex] = selectedWords
            console.log("當前已選文字數組：", selectedWords);

            // 解除 word_container 裡被選中的字的狀態
            $(".word_container .grid").each(function () {
                if ($(this).text().trim() === removedText) {
                    $(this).removeClass("grid_choose"); // 重新解鎖
                }
            });
        });
        // 通用綁定事件
        $('.close-btn').on('click', function () {
            $('.popup').fadeOut();
        });

        $('.role-tab').on('click', '.btn', function () {
            requestInterface.countNum('小櫻_第七期_移動端_點擊往期頁簽');
            $(this).addClass('selected').siblings().removeClass('selected').parent('.role-tab').siblings('.role-list-content').children('.role-list-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.cg_popup .close_btn').on('click', function () {
            $('.cg_popup').fadeOut();
        });
        $('.wechat_btn').on('click', function () {
            $('.wechat_popup').fadeIn();
        });

        $('.enterprise_wechat_btn').on('click', function () {
            $('.enterprise_wechat_popup').fadeIn();
        });

        $('.answer_pop .confirm_btn,.gift_pop .confirm_btn,.pass_box .confirm_btn,.fail_pop .confirm_btn').on('click', function () {
            $('.popup').fadeOut();
        });

        $('.wechat_box .confirm_btn').on('click', function () {
            $('.wechat_popup, .enterprise_wechat_popup').fadeOut();
        });

        $('.content-06 .award_list_btn').on('click', function () {
            $('.pass_popup').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_通關獎勵');
        });
        $('.content-02 .award_list_btn').on('click', function () {
            $('.award_list_popup').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_獎池列表');
        });
        $('.prize_btn').on('click', function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            $('.my_prize_popup').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_我的獎品');
        });
        $('.share_btn').on('click', function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            $('.share_popup').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_分享按鈕');
        });
        $('.content-02 .rule_btn').on('click', function () {
            $('.rule_popup').fadeIn();
            $('.rule_text_box1').fadeOut();
            $('.rule_text_box').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_規則按鈕');
        });
        $('.content-06 .rule_btn').on('click', function () {
            $('.rule_popup').fadeIn();
            $('.rule_text_box').fadeOut();
            $('.rule_text_box1').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_猜謎規則按鈕');
        });
        $('.rule_popup .confirm_btn').on('click', function () {
            $('.rule_popup').fadeOut();
        });

        $('.cg_btn').on('click', function () {
            const idx = $(this).attr('data-idx');
            $('.cg_box').attr('class', `cg_box popup_box cg_box_${idx}`);
            $('.cg_image').hide();
            $(`.cg_${idx}`).show();
            $('.cg_popup').fadeIn();
            requestInterface.countNum('小櫻_第七期_移動端_查看CG圖');
        });

        $('.award_list_box .confirm_btn').on('click', function () {
            $('.award_list_popup').fadeOut();
        });
        $('.my_prize .receive_btn').on('click', function () {
            if (awardNum === 0) {
                layer.msg("暫無可領取獎品");
                return false;
            }
            // 打開彈窗
            if (isBindRole) { // 已經綁定角色，提示獎勵領取到哪個角色
                $('.reward_popup').fadeIn();
            } else { // 未綁定的讓玩家綁定角色
                obj.serverInfo(config.account);
            }
            requestInterface.countNum('小櫻_第七期_移動端_一鍵領取');
        });
        $('.lottery_btn').on('click', function () {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            // 防抖
            const currentTime = Date.now();
            if (currentTime - lastClickTime < cutdown) {
                layer.msg("操作太快，請稍後再試", { time: 1000 });
                return false;
            }
            lastClickTime = currentTime;

            $('.prevent-wrap').show();
            requestInterface.lottery({}, function (response) {
                if (response.code == 200) {
                    const { prize_id, title, is_prize } = response.data;
                    if (is_prize == 0) {
                        $('.un_award_popup').fadeIn();
                    } else {
                        $('.prize_popup .prop').attr('class', `prop prop_${prize_id}`);
                        $('.prize_popup .prop_name').text(title);
                        $('.prize_popup').fadeIn();
                    }
                }
            });
            requestInterface.countNum('小櫻_第七期_移動端_抽獎按鈕');
        });

        $('.prize_popup .close-btn, .prize_popup .confirm_btn, .un_award_popup .confirm_btn').on('click', function () {
            $('.prize_popup, .un_award_popup').fadeOut();
            obj.onInit();
        });

        // 確認領獎
        $('.bind_confirm_popup .confirm_btn, .reward_popup .confirm_btn').on('click', function () {
            if (taskBind) {
                bindParams.is_bind = 0
            }
            requestInterface.reward({ ...bindParams }, function () {
                $('.my_prize_popup').fadeOut();
                $('.reward_popup').fadeOut();
                $('.bind_confirm_popup').fadeOut();
                if (taskBind) {
                    taskBind = 0
                    bindParams.is_bind = 1
                    layer.msg("成功綁定", { time: 2000 });
                } else {
                    layer.msg("領取成功", { time: 2000 });
                }
                obj.onInit();
            });
        });
        // 確認綁定-返回
        $('.bind_confirm_popup .return_btn').on('click', function () {
            bindParams = {};
            $('.bind_confirm_popup').fadeOut();
            obj.serverInfo(config.account);
        });
        $('.reward_popup .close-reward').on('click', function () {
            $('.reward_popup').fadeOut();
        });
        $('.bind_confirm_popup .close-bind').on('click', function () {
            $('.bind_confirm_popup').fadeOut();
        });
        $('.jump_btn').on('click', function () {
            const href = $(this).data('href');
            const eventName = $(this).attr('data-event');
            if (eventName) {
                requestInterface.countNum(eventName);
            }
            if (href) {
                window.location.href = href;
            }
        });

        // 下載按鈕
        $('.download_btn').on('click', function () {
            // 判斷是安卓還是蘋果
            requestInterface.countNum('港澳台小櫻_第七期_移動端_下載按鈕');
            if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
                window.location.href = 'https://play.google.com/store/apps/details?id=com.snell.sakura.ggp.tw'
            } else if (navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('iPad') > -1) {
                window.location.href = 'https://apps.apple.com/app/id6462015934'
            }
        });
        // 關閉下載提示
        $('.download_wrap').on('click', function () {
            $('.download_wrap').fadeOut();
        });

        var codeClipboard = new Clipboard(document.querySelector(".copy_link_btn"));
        codeClipboard.on("success", function (e) {
            layer.msg("已複製至剪貼板，快分享給好友吧~");
            requestInterface.countNum('小櫻_第七期_移動端_複製鏈接');
            return;
        });
        codeClipboard.on("error", function (e) {
            console.error("Action:", e.action);
            console.error("Trigger:", e.trigger);
        });
    },
    indexSwiper: function () {
        let mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,

            onInit: function (swiper) {
                swiperAnimate(swiper);
                obj.ThreeSixtyJs();

                function Ani(btn, page) {
                    $(btn).on('click', function () {
                        mySwiper.slideTo(page, 1000, true);
                    });
                };

                function navLink() {
                    for (var i = 4; i >= 0; i--) {
                        Ani('.nav-link-0' + i + ' .link-a', i);
                    };
                }
                navLink();
                var aniLink01 = Ani('.arrow-b', '1');
                var aniLink02 = Ani('.arrow-b2', '2');
                var aniLink03 = Ani('.arrow-b3', '3');
                var aniLink04 = Ani('.arrow-b4', '4');
                var aniLink05 = Ani('.arrow-b5', '5');

            },
            onTransitionStart: function (swiper) {
                swiperAnimate(swiper);
            },
        });

        const changeActivePage = (activeIndex) => {
            let idx = 1;
            if (activeIndex === 4) {
                idx = 5;
            } else if (activeIndex === 10) {
                idx = 1;
            } else {
                idx = activeIndex - 4;
            }
            $('.content-05 .page').attr('class', `page active_${idx}`);
        };

        let activeSwiper = new Swiper('.swiper-container2', {
            loop: true,
            effect: 'coverflow',
            paginationClickable: true,
            noSwiping: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            simulateTouch: false,
            // swipeHandler: '.swipe-handler',
            autoplayDisableOnInteraction: false,
            spaceBetween: 100,
            coverflow: {
                rotate: 0, // 旋轉的角度
                stretch: 17.7, // 拉伸   圖片間左右的間距和密集度
                depth: 30, // 深度   切換圖片間上下的間距和密集度
                modifier: 10, // 修正值 該值越大前面的效果越明顯
                slideShadows: false // 頁面陰影效果
            },
            onSlideChangeStart: function (swiper) {
                changeActivePage(swiper.activeIndex);
            },
            onTouchEnd: function (swiper) {
                changeActivePage(swiper.activeIndex);
            },
        });

        $('.content-05 .prev_btn').on('click', function () {
            activeSwiper.slidePrev();
        });
        $('.content-05 .next_btn-2').on('click', function () {
            activeSwiper.slideNext();
        });
        $('.content-05 .page span').on('click', function () {
            const idx = $(this).data('idx');
            activeSwiper.slideTo(idx + 4);
        });

        // 卡池展示
        let roleSwiper = new Swiper('.role_list_swiper_0', {
            spaceBetween: 0,
            initialSlide: 2,

            slidesPerView: 5,
            centeredSlides: !0,
            slideToClickedSlide: true,
            onlyExternal: true,
            loop: true,
            onSlideChangeStart: function (swiper) {
                const idx = $(swiper.clickedSlide).data('idx');
                $('.level_box .role_star').hide().siblings(`.role_star_${idx}`).fadeIn(100);
                $(`.threesixty-${idx}`).fadeIn().siblings('.threesixty').fadeOut();
                $(`.content-03 .role_intro_${idx}`).fadeIn().siblings('.content-03 .role_intro_item').fadeOut();
                $('.cg_btn').attr('data-idx', idx);
            }
        });

        // 往期回顧
        function newRoleSwiper(roleName, introName) {
            new Swiper(roleName, {
                spaceBetween: 0,
                initialSlide: 4,
                slidesPerView: 5,
                centeredSlides: !0,
                slideToClickedSlide: true,
                onlyExternal: true,
                loop: true,
                onSlideChangeStart: function (swiper) {
                    const idx = $(swiper.clickedSlide).data('idx');
                    // console.log("idx", idx);
                    $(introName).find('.role_intro_item').hide();
                    $(introName).find('.role_intro_' + idx + '').fadeIn(500);
                }
            });
        }

        var roleSwiper1 = newRoleSwiper('.role_list_swiper_1', '.role_intro_box_1');
        var roleSwiper2 = newRoleSwiper('.role_list_swiper_2', '.role_intro_box_2');
        var roleSwiper3 = newRoleSwiper('.role_list_swiper_3', '.role_intro_box_3');
        var roleSwiper4 = newRoleSwiper('.role_list_swiper_4', '.role_intro_box_4');

        $('.role_intro_5').fadeIn();
        $('.level_box .role_star_5').fadeIn();
    },
    ThreeSixtyJs: function () {
        function productInfo() {
            const fontUnit = Number($('html').css('font-size').replace('px', ''));
            const width = 16.2 * fontUnit;
            const height = 28.8 * fontUnit;
            const ext = '.png';
            $('.threesixty .threesixty_images').html('');
            var product1 = $('.threesixty-1').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-1',
                progress: '.spinner-1',
                imagePath: '/1/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product2 = $('.threesixty-2').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-2',
                progress: '.spinner-2',
                imagePath: '/2/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product3 = $('.threesixty-3').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-3',
                progress: '.spinner-3',
                imagePath: '/3/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product4 = $('.threesixty-4').ThreeSixty({
                totalFrames: 72,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-4',
                progress: '.spinner-4',
                imagePath: '/4/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product5 = $('.threesixty-5').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-5',
                progress: '.spinner-5',
                imagePath: '/5/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            $('.threesixty-5').fadeIn();
        }
        productInfo();
    },
    // 初始化用户信息
    onInitForTask: function () {
        requestInterface.init({}, function (response) {
            const { data } = response;
            if (response.code == 200) {
                const { user_info, activity } = data;
                activityInfo = activity;
                const taskLink = [
                    'https://sakura.snell.com.tw/index_mobile.html',
                    'https://www.facebook.com/ccsakuragame',
                    'https://www.instagram.com/sakura.memorykey',
                ]
                daysPassed = activityInfo.answer_info.number
                // 根據用戶信息中任務信息，判斷是否已經完成
                activity.answer_info.task_info.forEach(function (task, index) {
                    if (task._get) {
                        $(".task_pop .task_list li").eq(index).find(".move_btn").addClass("done_btn");
                    } else {
                        $(".task_pop .task_list li").eq(index).find(".move_btn").removeClass("done_btn");

                    }
                    let link = task.link ? task.link : taskLink[index] || "#";
                    $(".task_pop .task_list li").eq(index).find(".move_btn").attr("link", link);

                });
                $('.remaining .dice_times').text(`${activity.answer_info.dice_times}`)
            }

        });
    },
    // 初始化用戶信息
    onInit: function () {
        requestInterface.init({}, function (response) {
            const { data } = response;
            if (response.code == 200) {
                const { user_info, activity } = data;
                // console.log("user_info:", user_info);
                // console.log("activity:", activity);
                activityInfo = activity;
                const taskLink = [
                    'https://sakura.snell.com.tw/index_mobile.html',
                    'https://www.facebook.com/ccsakuragame',
                    'https://www.instagram.com/sakura.memorykey',
                ]
                daysPassed = activityInfo.answer_info.number
                obj.reloadTimeInit()
                // 根據用戶信息中任務信息，判斷是否已經完成
                activity.answer_info.task_info.forEach(function (task, index) {


                    if (task._get) {
                        $(".task_pop .task_list li").eq(index).find(".move_btn").addClass("done_btn");
                    } else {
                        $(".task_pop .task_list li").eq(index).find(".move_btn").removeClass("done_btn");

                    }
                    let link = task.link ? task.link : taskLink[index] || "#";
                    $(".task_pop .task_list li").eq(index).find(".move_btn").attr("link", link);

                });
                $('.remaining .dice_times').text(`${activity.answer_info.dice_times}`)

                let gift_arr = [1, 3, 5]
                let activeIndex = $(".lock_box .lock.unlock_active").index(); // 獲取當前激活的索引
                // 當前激活的索引是否是祝福索引
                let giftSgin = gift_arr.includes(activeIndex);
                for (var k = 0; k < activityInfo.answer_info.problem_info.length; k++) {
                    selectedWordsSureList[k] = activityInfo.answer_info.problem_info[k].now_get_number - 1
                }
                // 初始化已選的答案,當前答題不是第一個
                if (activityInfo.answer_info.now_answer_id > 1) {
                    // 初始化第一個
                    if (activeIndex == 0) {
                        answerWords = activityInfo.answer_info.problem_info[0].answer;
                        answerWords.split('').forEach(function (word, index) {
                            $(".choose_word_box .grid").eq(index).text(activityInfo.answer_info.problem_info[0].problem[word * 1]).addClass("grid_active");
                        })
                    }
                    // 保存已通过答案，默认已通过全为已确认
                    for (let i = 0; i < activityInfo.answer_info.now_answer_id - 1; i++) {
                        // 保存已回答答案
                        activityInfo.answer_info.problem_info[i].answer.split('').forEach(function (word, index) {
                            selectedWordsSureList[i] = 5
                            selectedWordsList[i][index] = activityInfo.answer_info.problem_info[i].problem[word * 1]
                        })
                        // 是否是當前祝福索引.祝福索引則改變按鈕，不改變word_intro,且題目是沒有答完
                        if (!giftSgin && activeIndex < activityInfo.answer_info.now_answer_id - 1) {
                            $('.word_intro').addClass('word_done')
                        } else {
                            $('.content_box .gift_intro .accept').addClass('accept_disabled')
                        }
                    }
                    if (activityInfo.answer_info.now_answer_id - 1 < 7) {
                        // 回填入当前需要答题关卡已确认字符
                        selectedWordsSureList[activityInfo.answer_info.now_answer_id - 1] = activityInfo.answer_info.problem_info[activityInfo.answer_info.now_answer_id - 1].now_get_number - 1

                        activityInfo.answer_info.problem_info[activityInfo.answer_info.now_answer_id - 1].answer.split('').forEach(function (word, index) {
                            console.log('index:', activityInfo.answer_info.problem_info[activityInfo.answer_info.now_answer_id - 1])
                            if (index < activityInfo.answer_info.problem_info[activityInfo.answer_info.now_answer_id - 1].now_get_number) {
                                selectedWordsList[activityInfo.answer_info.now_answer_id - 1][index] = activityInfo.answer_info.problem_info[activityInfo.answer_info.now_answer_id - 1].problem[word * 1]
                            } else {
                                selectedWordsList[activityInfo.answer_info.now_answer_id - 1][index] = ''
                                obj.taskInitNum = 0
                            }
                        })

                    }
                } else {
                    selectedWordsSure = selectedWordsSureList[0]
                    answerWords = activityInfo.answer_info.problem_info[0].answer;
                    selectedWords = ["", "", "", "", "", ""]
                    answerWords.split('').forEach(function (word, index) {
                        if (index <= selectedWordsSure) {
                            $(".choose_word_box .grid").eq(index).text(activityInfo.answer_info.problem_info[0].problem[word * 1]).addClass("grid_active");
                            selectedWords[index] = activityInfo.answer_info.problem_info[0].problem[word * 1];
                            selectedWordsList[0] = selectedWords
                        }
                    })
                }


                selectedWords = selectedWordsList[activeIndex]
                showSelectWordsFn()
                console.log(selectedWords, selectedWordsList, selectedWordsSureList)
                config.account = user_info.account;
                config.roleName = activity.role_name;
                config.moveRoleName = activity.notice.account;
                config.account = user_info.account;
                obj.updateHeader();
                // 更新我的獎池
                const rewardList = activity.reward_list;
                let rewardHtml = '';
                awardNum = 0;
                gameNum = activity.times;
                isBindRole = activity.is_bind == 1;
                if (isBindRole) {
                    const { role_id, role_name, server_id, server_name, platform } = activity;
                    bindParams = { role_id, role_name, server_id, server_name, platform };
                    $('.reward_popup .reward_box p span').text(`${role_name}(${server_name})`);
                } else {
                    bindParams = {};
                }
                if (activity.notice) {
                    const { account, title } = activity.notice;
                    $('.winner_box .role_name').text(account);
                    $('.winner_box .award_name').text(title);
                    $('.winner_box').show();
                } else {
                    $('.winner_box').hide();
                }
                rewardList.forEach((item) => {
                    if (item.is_send === 0) {
                        awardNum++;
                    }
                    rewardHtml += `<li class="${item.is_send === 1 ? 'reward' : ''}"><p><span> <span> ${item.remark}</span></span></p></li>`;
                });

                if (rewardList.length > 4) {
                    $('.my_prize_popup .more_icon').show();
                } else {
                    $('.my_prize_popup .more_icon').hide();
                }

                $('.my_prize_popup .list ul').html(rewardHtml);
                $('.content-02 .operation .number span').text(activity.times);
                const getRandomString = () => {
                    return Math.random().toString(36).slice(2);
                }
                $('.copy_link_btn').attr('data-clipboard-text', `${shareText}https://sakura.snell.com.tw/m-card-7/enter${getRandomString()}?helper_id=${activity.user_id}`);

                // 將幫助id存儲到localStorage
                var helperId = window.localStorage.getItem('helper_id') || '';
                var helperIdArr = helperId ? helperId.split(',') : [];
                if (!helperId.includes(activity.user_id)) {
                    // 如果id在緩存中不包含則進行記錄
                    helperIdArr.push(activity.user_id);
                    window.localStorage.setItem('helper_id', helperIdArr.join(','));
                }
                obj.helpRecord();
            } else {
                obj.openLoginPopup();
            }
        });
    },
    // 打開登陸彈窗
    openLoginPopup: function () {
        $('.inp-account').val('');
        $('.inp-name').val('');
        $('.phone-inp').val('');
        $('input[name=sms_code]').val('');
        $('.inp-role-name').val('');
        $('.inp-role-id').val('');
        clearTimeout(timer);
        wait = 60;
        setTimeout(() => {
            $('.obtain-verification label span a').remove();
            $('.obtain-verification label span').html("<a>發送</a>");
        }, 100);
        $('.register-popup').fadeIn();
    },
    // 登陸彈窗相關事件綁定
    loginEventBind: function () {
        // 切換登陸方式
        $('.register-box .title').on('click', 'div', function (event) {
            $(this).addClass('active').siblings().removeClass('active');
            for (var i = 0; i <= 2; i++) {
                $('.form-main').removeClass('move-' + i + '')
            };
            $('.form-main').addClass('move-' + $(this).attr('data') + '')
        });
        // 登陸彈窗關閉按鈕
        $('.register-popup .close-bg').on('click', function () {
            $('.register-popup').fadeOut();
        });
        // 光子服/正式服 切換
        $('.tab-server').on('click', 'div', function (event) {
            $(this).addClass('active').siblings().removeClass('active')
                .parent('.tab-server').siblings('.option-main')
                .children('.option-box').eq($(this).index())
                .addClass('show').siblings().removeClass('show');

            $('.gzf select').val('0')
            $('.gzf input[name=gzf_role_name]').val('')
            $('.zsf-os').val('')
            $('.zsf-server').val('')
            $('.zsf input[name=zsf_role_name]').val('');

            bindParams = {
                game_id: $(this).parent().find('.active').attr('data-game-id'),
                role_id: "",
                role_name: "",
                server_id: "",
                server_name: "",
                type: ""
            };
        });

        // 賬戶登陸
        $('.login-btn').click(function (event) {
            const account = $('.inp-account').val();
            const name = $('.inp-name').val();
            if (account == '') {
                layer.msg("請輸入您的賬號", { time: 2000 });
                return false;
            }
            if (name == '') {
                layer.msg("請輸入您的昵稱", { time: 2000 });
                return false;
            }
            requestInterface.accountLogin({ role_id: account, role_name: name, game_id: 60, card: 1 }, function (response) {
                localStorage.setItem('access_token', response.data.access_token);
                $('.popup').fadeOut();
                obj.onInit();
            });
        });
        // 驗證碼登陸
        $('.sms-login').click(function () {
            const account = $('.phone-inp').val();
            const code = $('input[name=sms_code]').val();

            if (account == '') {
                layer.msg("請輸入正確的手機號", { time: 2000 });
                return false;
            }
            if (!code) {
                layer.msg("請輸入您的驗證碼", { time: 2000 });
                return false;
            }

            requestInterface.smsLogin({ account, sms_code: code, is_remember: 1 }, function (response) {
                localStorage.setItem('access_token', response.data.access_token);
                $('.popup').fadeOut();
                obj.onInit();
            });
        });

        // 驗證碼發送
        $('.obtain-verification').on('click', 'a', function (event) {
            const phone = $('.phone-inp');
            if (!phone.val()) {
                layer.msg("請輸入手機號", { time: 2000 });
                phone.focus();
                return false;
            }
            requestInterface.sendSms(phone.val());
        });

        // 綁定角色
        $('.confirm-btn').click(function (event) {
            // console.log(bindParams);
            if (bindParams.role_id == undefined) {
                layer.msg("請先選擇信息");
                return false;
            }
            // TODO: 二次確認彈窗
            $('.bind_confirm_popup .bind_confirm_box p span').text(`${bindParams.role_name}(${bindParams.server_name})`);
            $('.server-popup').fadeOut();
            $('.bind_confirm_popup').fadeIn();
        });
        $('.cancell-btn').on('click', function () {
            $('.server-popup').fadeOut();
        });

        $('.channel-cancell-btn').click(function (event) {
            obj.onLogout();
        });

        // 頭部點擊
        $('.header .login_btn').on('click', function () {
            obj.openLoginPopup();
            requestInterface.countNum('港澳台小櫻_第六期_移動端_登陸按鈕');
        });
        $('.header .logout_btn').on('click', function () {
            $('.logout-popup').fadeIn();
            requestInterface.countNum('港澳台小櫻_第六期_移動端_註銷按鈕');
        });
        $('.logout-popup .close-bg').on('click', function () {
            $('.logout-popup').fadeOut();
        });
    },
    serverInfo: function (account) {
        // 初始化打開狀態
        $('.tab-server').show();
        $('.tab-server').find('.active').removeClass('active');
        $('.tab-server').find('div:first').addClass('active');
        $('.gzf').addClass('show');
        $('.zsf').removeClass('show');
        $('input[name=gzf_role_name]').val('');
        $('input[name=zsf_role_name]').val('');

        // 初始化參數狀態
        bindParams = {};
        requestInterface.getRoleList({}, function (json) {
            var xff = json.data[60]
            if (!xff) {
                layer.msg("查無您的角色信息")
                return false;
            } else {
                $('.tab-server').show();
            }

            if (xff) {
                $('.gzf select').html('<option value="0">請選擇區組</option>');
                var list = xff.android;
                for (var key in list) {
                    var value = list[key];
                    const jsonExtra = JSON.stringify(value['extra'])
                    $('.gzf select').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id'] + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] + '</option>')
                }

                $('.gzf select').off('change').on('change', function () {
                    var option = $(this).find('option:selected');
                    // console.log('option', option.val());
                    if (option.val() && option.val() != '0') {
                        // 改值
                        $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
                        bindParams = {
                            game_id: 60,
                            role_id: option.attr('data-role_id'),
                            role_name: option.attr('data-role-name'),
                            server_id: option.attr('data-serverId'),
                            server_name: option.attr('data-server_name'),
                            type: "android",
                            platform: option.attr('data-platform'),
                            extra: option.attr('data-extra')
                        }
                    } else {
                        // 清空
                        $('input[name=gzf_role_name]').val('');
                        bindParams = {}
                    }
                });
            } else {
                $('.gzf').removeClass('show');
            }



            $('.inp-account').val(''); // 賬號密碼清空
            $('.inp-name').val(''); // 賬號密碼清空
            $('.register-popup').fadeOut(); // 關閉登陸頁面
            $('.server-popup').fadeIn(); // 開啟伺服器
        });
    },
    updateHeader: function () {
        if (config.account) {
            $('.header .info .intro').text(config.roleName);
            $('.header .login_btn').hide();
            $('.header .logout_btn').show();
        } else {
            $('.header .info .intro').text('請先登入');
            $('.header .login_btn').show();
            $('.header .logout_btn').hide();

        }
    },
    onLogout: function () {
        requestInterface.logout(function (json) {
            if (json.code == 200) {
                $('#account').html('請先登入');
                $('#server_name').html('');
                $('#role_name').html('');

                config.role_id = '';
                config.account = '';
                awardNum = 0;
                gameNum = 0;
                isBindRole = false;
                bindParams = {};

                obj.updateHeader();
                $('.content-02 .operation .number span').text(0);
                $('.my_prize_popup .list ul').html('');
                localStorage.setItem('access_token', '');
                localStorage.setItem('roleID', '');
                localStorage.setItem('sign', '');




                lockStatus = ["lock", "lock", "lock", "lock", "lock", "lock", "lock"];
                selectedWordsList = [
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                    ["", "", "", "", "", ""],
                ];
                selectedWordsSureList = [
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    -1
                ];
                selectedWordsSure = [];
                selectedWords = ["", "", "", "", "", ""]
                showWords = ['蛋', '生', '樂', '的', '小', '日', '快', '愛', '櫻', '糕'];
                $(".word_container .grid").each(function (index) {
                    if (index < showWords.length) {
                        $(this).text(showWords[index]);  // 赋值文字
                    } else {
                        return false; // 避免越界
                    }
                });
                answerWords = '';
                wordList = [
                    ['蛋', '生', '樂', '的', '小', '日', '快', '愛', '櫻', '糕'],
                    [],
                    ['刻', '線', '時', '鐘', '定', '限', '法', '表', '一', '魔'],
                    [],
                    ['運', '星', '櫻', '行', '出', '走', '天', '幸', '小', '春'],
                    [],
                    ['羽', '心', '純', '翔', '翼', '翅', '飛', '白', '箱', '春']
                ]
                rewards_list = [
                    ['星之幣*200', '3~5星小小櫻碎片寶箱*3'],
                    [],
                    ['櫻花幣*50', '友枝幣*200W',],
                    [],
                    ['星之幣*200', '3~5星小小櫻碎片寶箱*5'],
                    [],
                    ['小櫻專屬頭像框*1', '高級盲盒兌換券*2']
                ]

                // 清空所有 grid_text 状态
                $(".choose_word_box .grid").text("").removeClass("grid_active");
                $(".choose_word_box .grid").text("").removeClass("grid_text");
                // 移除 `.word_container .grid` 的 `grid_choose` 类
                $(".word_container .grid").removeClass("grid_choose");
                $(".lock_box .lock").each(function (index) {
                    console.log('index', index)
                    $(this).removeClass("unlock");
                    $(this).removeClass("unlock_active");
                });
                $('.word_intro').removeClass('word_done')

                $('.remaining .dice_times').text(`0`)
                daysPassed = 0;
                obj.reloadTimeInit()
                $('.gift_intro').fadeOut()
                $('.word_box ').fadeIn()
            }
        });
        $('.popup').fadeOut();
    },
}

requestInterface = {

    accountLogin: function (data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/sea/login",
            type: "POST",
            xhrFields: { withCredentials: true },
            data,
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function () {
                layer.close(index)
            }
        });
    },
    smsLogin: function (data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + '/snail/login/sms',
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
            }
        })
    },
    sendSms: function (phone) {
        const index = layer.load(1);
        $.ajax({
            url: api + '/snail/login/sms/send',
            type: "POST",
            data: { mobile: phone, channel: "login" },
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                } else {
                    // 倒计时
                    time();
                }
            },
            complete: function () {
                layer.close(index);
            }
        });
    },
    logout: function (callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/sea/cherry/taiwan/draw/logout",
            type: "POST",
            data: { key: activeKey },
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                } else {
                    layer.msg('登出成功');
                }
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
            }
        });
    },
    getRoleList: function (data, callback) {
        data.key = activeKey;
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: `${api}/sea/cherry/taiwan/draw/role?access_token=${data.access_token}&key=${data.key}`,
            type: "GET",
            xhrFields: { withCredentials: true },
            success: function (json) {

                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                // console.log(json);
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
            }
        });
    },

    // 業務接口
    init: function (data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        // const index = layer.load(1);
        $.ajax({
            url: `${api}/sea/cherry/taiwan/draw/init?access_token=${data.access_token}&key=${activeKey}`,
            type: "GET",
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    if (json.message !== '很抱歉,請先登錄') layer.msg(json.message);
                } else {
                    localStorage.setItem('token', json.data.activity.token);
                    localStorage.setItem('access_token', json.data.activity.access_token);
                }
                callback && callback(json);
            },
            complete: function () {
                // layer.close(index);
            }
        });
    },
    share: function (data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/sea/cherry/taiwan/draw/share",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function (json) {
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
            }
        });
    },
    lottery: function (data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/sea/cherry/taiwan/draw/lottery",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                // {
                //   "code": 200,
                //   "message": "ok",
                //   "data": {
                //     "prize_id": 1,
                //     "is_good": 0
                //   }
                // }
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
                $('.prevent-wrap').hide();
            }
        });
    },
    reward: function (data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/sea/cherry/taiwan/draw/reward",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function (json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function () {
                layer.close(index);
                $('.prevent-wrap').hide();
            }
        });
    },
    // 阿里云埋點
    countNum: function (data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    },
};

// 验证码倒计时
function time() {
    if (wait == 0) {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<a>发送</a>");
        wait = 60;
    } else {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<b>" + wait + "秒</b>");
        wait--;
        timer = setTimeout(function () {
            time()
        }, 1000);
    }
}

function analysisParams(url) {
    const params = {};
    const paramsString = url.split('?')[1];
    if (!paramsString) {
        return params;
    }
    const str = paramsString.split('&');
    for (let idx = 0; idx < str.length; idx++) {
        const values = str[idx].split('=');
        params[values[0]] = values[1];
    }
    return params;
};